const AUTO_SCROLL_ATTR = 'autoScrollLocked';
export const AUTO_SCROLL_THRESHOLD_PX = 48;

export function isNearBottom(
  element: HTMLElement,
  thresholdPx = AUTO_SCROLL_THRESHOLD_PX,
): boolean {
  return element.scrollHeight - element.scrollTop - element.clientHeight <= thresholdPx;
}

export function isAutoScrollEnabled(element: HTMLElement | null): boolean {
  if (!element) return false;
  return element.dataset[AUTO_SCROLL_ATTR] !== 'false';
}

export function updateAutoScrollState(
  element: HTMLElement | null,
  thresholdPx = AUTO_SCROLL_THRESHOLD_PX,
): boolean {
  if (!element) return false;
  const enabled = isNearBottom(element, thresholdPx);
  element.dataset[AUTO_SCROLL_ATTR] = enabled ? 'true' : 'false';
  return enabled;
}

export function enableAutoScroll(element: HTMLElement | null): void {
  if (!element) return;
  element.dataset[AUTO_SCROLL_ATTR] = 'true';
}

export function scrollToBottom(element: HTMLElement | null): void {
  if (!element) return;
  element.scrollTop = element.scrollHeight;
  updateAutoScrollState(element);
}

export function scrollToBottomIfEnabled(element: HTMLElement | null): void {
  if (!element || !isAutoScrollEnabled(element)) return;
  scrollToBottom(element);
}
